const scrollToBottom = (node: HTMLDivElement) => {
  const scrollHeight = node.scrollHeight;
  const height = node.clientHeight;
  const maxScrollTop = scrollHeight - height;
  node.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
};

export default scrollToBottom;
